export const CAMPAIGN_CONFIG_FLAG_PREFIX = "crumbs-opd-config";
